function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["title", "content", "trigger", "type", "children", "overlayClassName", "placement", "visible", "defaultVisible", "onVisibleChange", "showCloseBtn", "hideAnimate", "showArrow", "noPadding", "disabled", "onClose"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useRTL } from "../../../hooks/useRTL";
import { cn } from "../../../lib/utils";
import { CirclepromptIcon, CloseIcon, HelpIcon, PlacardIcon } from '@bfe/moly-icons';
import RcTooltip from 'rc-tooltip';
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { IconButton } from "../iconbutton";
import getPlacements from "./placements";
import { injectPopoverStyles } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
injectPopoverStyles();
var prefixCls = 'moly-popover';
var Popover = /*#__PURE__*/memo(function (_ref) {
  var title = _ref.title,
    content = _ref.content,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger,
    type = _ref.type,
    children = _ref.children,
    overlayClassName = _ref.overlayClassName,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    visible = _ref.visible,
    defaultVisible = _ref.defaultVisible,
    onVisibleChange = _ref.onVisibleChange,
    _ref$showCloseBtn = _ref.showCloseBtn,
    showCloseBtn = _ref$showCloseBtn === void 0 ? false : _ref$showCloseBtn,
    _ref$hideAnimate = _ref.hideAnimate,
    hideAnimate = _ref$hideAnimate === void 0 ? false : _ref$hideAnimate,
    _ref$showArrow = _ref.showArrow,
    showArrow = _ref$showArrow === void 0 ? true : _ref$showArrow,
    _ref$noPadding = _ref.noPadding,
    noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onClose = _ref.onClose,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isRTL = useRTL();
  var overlayClass = useMemo(function () {
    var typeClass = type ? "moly-popover-".concat(type) : '';
    var animateClass = hideAnimate ? 'moly-popover-no-animate' : '';
    var noPaddingClass = noPadding ? 'moly-popover-no-padding' : '';
    var noTitle = !title ? 'moly-popover-no-title' : '';
    var showClose = showCloseBtn ? 'moly-popover-show-close' : '';
    return cn(typeClass, 'font-IBM', overlayClassName, animateClass, noPaddingClass, noTitle, showClose);
  }, [type, hideAnimate, noPadding, title, showCloseBtn, overlayClassName]);
  var controlled = useMemo(function () {
    return visible !== null && visible !== undefined;
  }, [visible]);
  var defaultVisibleTemp = controlled ? visible : defaultVisible;
  var _useState = useState(defaultVisibleTemp || false),
    _useState2 = _slicedToArray(_useState, 2),
    visibleState = _useState2[0],
    setVisibleState = _useState2[1];
  useEffect(function () {
    if (controlled) {
      setVisibleState(Boolean(visible));
    }
  }, [visible, controlled]);
  var onVisibleStateChange = useCallback(function (v) {
    onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(v);
    if (!controlled) {
      setVisibleState(v);
    }
  }, [controlled, onVisibleChange]);
  var handleClose = useCallback(function () {
    onClose === null || onClose === void 0 || onClose();
    onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(false);
    if (!controlled) {
      setVisibleState(false);
    }
  }, [controlled, onClose, onVisibleChange]);
  var titleTemplate = useMemo(function () {
    var icon = null;
    var clzName = cn('absolute', '!w-[14px]', '!h-[14px]', isRTL ? 'moly-popover-right-3 moly-popover-rotate' : 'moly-popover-left-3');
    if (type === 'info') {
      icon = /*#__PURE__*/_jsx(HelpIcon, {
        className: clzName
      });
    } else if (type === 'highlight') {
      icon = /*#__PURE__*/_jsx(PlacardIcon, {
        className: clzName
      });
    } else if (type === 'warning') {
      icon = /*#__PURE__*/_jsx(CirclepromptIcon, {
        className: clzName
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [icon, /*#__PURE__*/_jsx("span", {
        className: cn(showCloseBtn ? 'me-7' : ''),
        children: title
      }), showCloseBtn ? /*#__PURE__*/_jsx(IconButton, {
        variant: "default",
        className: cn('absolute top-3 cursor-pointer', isRTL ? 'moly-popover-left-3' : 'moly-popover-right-3', _defineProperty({}, '!text-base-bds-static-white', type === 'warning')),
        size: 'x-small',
        onClick: handleClose,
        children: /*#__PURE__*/_jsx(CloseIcon, {})
      }) : null]
    });
  }, [isRTL, type, title, handleClose, showCloseBtn]);
  var getOverlay = useCallback(function () {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: cn("".concat(prefixCls, "-title"), _defineProperty(_defineProperty({}, '!pr-8', type && isRTL), '!pl-8', type && !isRTL)),
        children: titleTemplate
      }), /*#__PURE__*/_jsx("div", {
        className: cn("".concat(prefixCls, "-inner-content"), isRTL ? 'text-right' : 'text-left', !title && showCloseBtn ? 'me-[28px]' : '', _defineProperty(_defineProperty({}, '!pr-8', type && isRTL), '!pl-8', type && !isRTL)),
        children: content
      })]
    });
  }, [content, isRTL, showCloseBtn, title, titleTemplate, type]);
  var placements = useMemo(function () {
    var result = getPlacements({
      arrowWidth: 12,
      borderRadius: 8,
      offset: 0
    });
    return result;
  }, []);
  return disabled ? children : /*#__PURE__*/_jsx(RcTooltip, _objectSpread(_objectSpread({
    trigger: trigger,
    placement: placement,
    overlayClassName: overlayClass,
    visible: visibleState,
    onVisibleChange: onVisibleStateChange,
    builtinPlacements: placements,
    getTooltipContainer: function getTooltipContainer() {
      return typeof document === 'undefined' ? undefined : document.body;
    },
    overlay: getOverlay(),
    prefixCls: prefixCls,
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    showArrow: showArrow
  }, otherProps), {}, {
    children: children
  }));
});
Popover.displayName = 'Popover';
export { Popover };